<template>
  <div class="d-flex flex-grow-1 align-items-center">
    <i
      :class="`fa fa-fw ${icon}`"
    ></i>
    <span>{{ typeLabel }}</span>
    <span
      class="small text-muted ml-auto"
    >
      {{ when }}
    </span>
  </div>
</template>

<script>
import { diffForHumans } from '@/lib/moment'

export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon () {
      return ''
    },
    typeLabel () {
      return ''
    },
    when () {
      return this.notification.created_at ? diffForHumans(this.notification.created_at) : null
    }
  }
}
</script>